import React from 'react';
import styled from 'styled-components';
import { gutter } from '../../styles/mixins';
import { m32 } from '../../styles/typography';

const Host = styled.div`
  padding: ${gutter(5)} 0;
`;
const Title = styled.div`
  ${m32};
  margin-bottom: ${gutter(4)};
`;

const Children = styled.div``;

interface LegoItemProps {
  title: string;
  children: React.ReactNode;
}

export const LegoItem = ({ title, children }: LegoItemProps) => {
  return (
    <Host>
      <Title>{title}</Title>
      <Children>{children}</Children>
    </Host>
  );
};
